export class VariableClient {
  nom
  type
  tags
  description
  reference
  referenceObj = null
  valeurDefaut
  valeurDefautObj = null

  constructor(nom = '', type = null, reference = null, tags = [], description = '', valeurDefaut = '') {
    this.nom = nom
    this.type = type
    this.reference = reference
    this.tags = tags
    this.description = description
    this.valeurDefaut = valeurDefaut
  }

  static NULL = new VariableClient()
}
